export const createRecordAdapter = (rowData: Record<string, any>) => {
	const values: Record<string, any> = { ...rowData };
	const errors: Record<string, string[]> = {};

	return {
		get: (field: string) => values[field],
		set: (field: string, value: any) => {
			values[field] = value;
		},
		addError: (field: string, msg: string) => {
			if (!errors[field]) errors[field] = [];
			errors[field].push(msg);
		},
		getValues: () => values,
		getErrors: () => errors,
	};
};
